module.exports = __webpack_public_path__ + "img/floorplan-icon.b9365f1f.svg";